import React from "react";
import { Avatar } from "@/types/interfaces";
import PickerModal from "../PickerModal";

interface GenderModalProps {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
  newAvatar: Avatar;
  handlePickerChange: (key: string, value: object) => void;
}

const genderOptions = ["Male", "Female", "Non-Binary", "Prefer Not To Say"];

const GenderModal: React.FC<GenderModalProps> = ({
  open,
  onClose,
  newAvatar,
  handlePickerChange,
  onCancel,
}) => {
  const initialValues = [newAvatar.genderPicker || "Female"];

  return (
    <PickerModal
      open={open}
      onClose={onClose}
      onCancel={onCancel}
      title="Select gender"
      columns={[{ items: genderOptions }]}
      onChange={([val]) => {
        handlePickerChange("genderPicker", { genderPicker: val });
      }}
      initialValues={initialValues}
    />
  );
};

export default GenderModal;
